import { CompanyFeeGroup, CompanyStatus, CompanyType } from '@aslanpay/portal-common-lib';

export const CompanyTypeLabels: Record<CompanyType, string> = {
  STANDARD: 'Standard',
  GIFTING_ONLY: 'Gifting only',
};

export const CompanyFeeGroupLabels: Record<CompanyFeeGroup, string> = {
  NO_FEE: 'No fees applied',
  DEFAULT_FEE: 'Default FX fee',
};

export const CompanyStatusValues: Record<CompanyStatus, { color: string; value: string }> = {
  AWAITING_KYB: { color: 'created', value: 'Awaiting KYB' },
  VERIFIED: { color: 'active', value: 'Verified' },
  DELETED: { color: 'deleted', value: 'Deleted' },
  KYB_DECLINED: { color: 'deleted', value: 'KYB Declined' },
};

export const CompanyTypesLabels: Record<CompanyType, string> = {
  STANDARD: 'Standard',
  GIFTING_ONLY: 'Gifting only',
};

export default CompanyStatusValues;
